(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form'), select = root.querySelector('[data-variants]'), add = form.querySelector('.wf-add'), status = root.querySelector('[role="status"]'), sticky = root.querySelector('.wf-sticky');
    const photo = root.querySelector('.wf-photo'), thumbs = [...root.querySelectorAll('[data-photo]')];
    let photoIndex = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
    let busy = false;
    let navigating = false;
    const cartLink = root.querySelector('.wf-cart-link');
    cartLink.hidden = false;
    window.addEventListener('pageshow', () => { busy = false; navigating = false; syncVariant(); });
    root.querySelector('.wf-variant-fallback').hidden = true;
    function showPhoto(index) {
      if (!thumbs.length) return;
      photoIndex = (index + thumbs.length) % thumbs.length;
      photo.removeAttribute('srcset');
      photo.src = thumbs[photoIndex].dataset.photo;
      photo.alt = thumbs[photoIndex].dataset.photoAlt;
      thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i === photoIndex)));
    }
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>showPhoto(i)));
    root.querySelectorAll('[data-photo-step]').forEach(b=>b.addEventListener('click',()=>showPhoto(photoIndex+Number(b.dataset.photoStep))));
    function syncVariant() {
      const opt = select.selectedOptions[0];
      if (!opt) return;
      root.querySelectorAll('[data-price],[data-button-price],[data-sticky-price]').forEach(e=>e.textContent=opt.dataset.price);
      root.querySelectorAll('input[type="radio"]').forEach(e=>e.checked=e.value === opt.value);
      const label=root.querySelector('[data-color-label]');
      if(label) label.textContent=opt.dataset.title;
      const unavailable=opt.dataset.available !== 'true';
      add.disabled=unavailable||busy;
      root.querySelector('[data-add-label]').textContent=busy?root.dataset.adding:(unavailable?root.dataset.sold:root.dataset.add);
      const stickyAdd=root.querySelector('[data-sticky-add]');
      stickyAdd.disabled=unavailable||busy;
      stickyAdd.textContent=busy?root.dataset.adding:(unavailable?root.dataset.sold:root.dataset.add);
      if(opt.dataset.image && !busy) {
        const index=thumbs.findIndex(t=>t.dataset.photo.split('?')[0]===opt.dataset.image.split('?')[0]);
        if(index>=0)showPhoto(index);
        else {photo.removeAttribute('srcset');photo.src=opt.dataset.image;photo.alt=opt.dataset.title;}
      }
    }
    select.addEventListener('change',syncVariant);
    root.querySelectorAll('input[type="radio"]').forEach(r=>r.addEventListener('change',()=>{
      select.value=r.value;syncVariant();
      const url=new URL(window.location.href);url.searchParams.set('variant',r.value);history.replaceState({},'',url);
      status.hidden=true;
    }));
    const quantity=form.querySelector('[name="quantity"]');
    root.querySelectorAll('[data-quantity]').forEach(b=>b.addEventListener('click',()=>{
      quantity.value=Math.max(1,(parseInt(quantity.value,10)||1)+Number(b.dataset.quantity));
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    quantity.addEventListener('change',()=>{quantity.value=Math.max(1,parseInt(quantity.value,10)||1)});
    form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy||add.disabled||!form.reportValidity())return;
      const item = {id:Number(select.value),quantity:Number(quantity.value)};
      busy=true;syncVariant();status.hidden=true;
      try {
        const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[item]})});
        const result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:root.dataset.failed);
        status.textContent=root.dataset.added;
        document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=String((parseInt(n.textContent,10)||0)+item.quantity));
        window.location.assign(cartLink.href);
        navigating=true;
      }catch(error){status.textContent=error.message||root.dataset.failed;}finally{busy=navigating;syncVariant();status.hidden=false;}
    });
    if('IntersectionObserver' in window)new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0;},{threshold:0}).observe(form);
    syncVariant();
  }
  document.querySelectorAll('[data-wf-product]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wf-product]').forEach(init));
})();
